module.exports = __webpack_public_path__ + "static/media/phone_idle_sel.1e6224a6.svg";